import React, {useCallback, useEffect, useRef, useState} from "react";
import shopifyFileUpload from "@helpers/shopify-upload";

const SearchByImage = () => {
    const [liveChatState, setLiveChatState] = useState(false);
    const [uploading, setUploading] = useState(false);
    const searchByImageRef = useRef(null);

    const handleFileChange = useCallback(async (e) => {

        if (!e?.target?.files[0]) {
            if (liveChatState) {
                LiveChatWidget.call("maximize");
            }
            return;
        };

        setUploading(true);

        try {
            let imageUrl = await shopifyFileUpload({ referenceImage: e?.target?.files[0] });

            setUploading(false);

            LiveChatWidget.call("maximize", { messageDraft: `I would like to know more about this product: ${imageUrl.referenceImage}` });
        } catch (error) {
            setUploading(false);
        }
    }, [liveChatState]);

    async function searchByImageClicked() {
        setLiveChatState(LiveChatWidget.get("state")?.visibility !== "minimized");
        LiveChatWidget.call("minimize");
    }

    useEffect(() => {
        searchByImageRef.current?.addEventListener("cancel", handleFileChange);
        searchByImageRef.current?.addEventListener("change", handleFileChange);

        return () => {
            searchByImageRef.current?.removeEventListener("cancel", handleFileChange);
            searchByImageRef.current?.removeEventListener("change", handleFileChange);
        }
    })

    return (
        <label aria-label="Search by Image" className={`header__search-image ${uploading ? "header__search-image--uploading" : ""}`} onClick={searchByImageClicked}>
            {uploading ? "Uploading..." : "Search by Image"}
            <input ref={searchByImageRef} type="file" accept="image/*" style={{ display: "none" }} />
        </label>
    );
};

export default SearchByImage;
